// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__15k1O","row":"ProcedureTreatmentSummary_row__3llhY"};